document.addEventListener('DOMContentLoaded', () => {
  const carouselContent = document.querySelectorAll('.mtt-image-carousel__content')
  const carouselImages = document.querySelectorAll('.mtt-image-carousel__image')

  if (carouselImages.length > 0) {
    carouselImages.forEach(el => {
      el.addEventListener('mouseenter', () => handleMouseenter(carouselContent))
      el.addEventListener('mouseleave', () => handleMouseleave(carouselContent))
    })
  }
})

function pauseAnimation (el) {
  el.style.animationPlayState = 'paused'
}

function resumeAnimation (el) {
  el.style.animationPlayState = ''
}

function handleMouseenter (els) {
  els.forEach(el => pauseAnimation(el))
}

function handleMouseleave (els) {
  els.forEach(el => resumeAnimation(el))
}